/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aichatdescription2Inputs */

const en_aichatdescription2 = /** @type {(inputs: Aichatdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation with Pulsify about your event`)
};

const de_aichatdescription2 = /** @type {(inputs: Aichatdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespräch mit Pulsify zu deinem Event`)
};

/**
* | output |
* | --- |
* | "Conversation with Pulsify about your event" |
*
* @param {Aichatdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aichatdescription2 = /** @type {((inputs?: Aichatdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aichatdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aichatdescription2(inputs)
	return de_aichatdescription2(inputs)
});
export { aichatdescription2 as "aiChatDescription" }